module.exports = __webpack_public_path__ + "img/Danie_O_4.9637be17.jpg";